var render, staticRenderFns
import script from "./form_detail.vue?vue&type=script&lang=js&"
export * from "./form_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('484fa86c')) {
      api.createRecord('484fa86c', component.options)
    } else {
      api.reload('484fa86c', component.options)
    }
    
  }
}
component.options.__file = "found/views/kms_new/views/finance/financial_auditing/audit_matching/form/form_detail.vue"
export default component.exports